// Environment detection — hostname exact match (no substring search).
// Production hosts (eifu.raymedical.com and any non-dev host) fall through to 'production'
// and use the production data proxy (api-teams-info.rayteams.com).
// Development hosts: localhost / 127.0.0.1 / *.raydevelop.com.
// NOTE: if an eIFU dev/staging domain outside *.raydevelop.com is introduced,
// extend the development matches below so it resolves the development proxy.
export const getEnv = () => {
  const host =
    (typeof window !== 'undefined' && window.location && window.location.hostname) || '';

  if (host === 'localhost' || host === '127.0.0.1') {
    return 'development';
  }

  if (host === 'raydevelop.com' || host.endsWith('.raydevelop.com')) {
    return 'development';
  }

  return 'production';
};

// Auth header helper retained for the data proxy (legacy DoDB v1 path).
// The eIFU portal performs anonymous downloads and never authenticates, so no
// token is attached — and we deliberately avoid reading any client-side storage
// here to keep the portal free of cookies / persisted identifiers.
export const JWT = () => ({
  headers: {
    'x-ray-device': 'WEB',
  },
});
